import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { installAuthInterceptor } from '@/services/authInterceptor'

installAuthInterceptor()

createApp(App).use(router).mount('#app')
